import classNames from 'classnames';
import * as React from 'react';

import * as styles from './MapWrapper.css';

interface IMapWrapperProps {
  fixedHeight?: boolean;
}

export const MapWrapper: React.FC<IMapWrapperProps> = ({ children, fixedHeight }) => {
  return <div className={classNames(styles['wrapper'], fixedHeight && styles['fixed-height'])}>{children}</div>;
};
